import { useContext } from "react";
import { ScrollLockContext } from "./ScrollLockContext";

export function useScrollLock() {
  return useContext(ScrollLockContext);
}
